// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__j28IE","navbarMain":"Navbar_navbarMain__tiGoZ","link":"Navbar_link__PrBJ2"};